import {separateCamelCaseWithCaps} from '../../../../helpers';
import * as Assets from '../../../../assets/images/images';

const formatLabel = text => {
  if (!text) return '';
  const processed = text.includes('_')
    ? text.split('_').join(' ')
    : text.replace(/([A-Z])/g, ' $1');
  return processed
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
const getSubRuleTheme = type =>
  ({
    all: {
      icon: Assets.andIcon,
      color: '#9FBDED',
    },
    any: {
      icon: Assets.orIcon,
      color: '#FB9855',
    },
  }[type || 'all']);

const extractFields = (obj = {}) =>
  Object.keys(obj || {}).map(c => ({
    value: c,
    label: formatLabel(c),
  }));

const findParentByChild = (selectedChild, data = {}) => {
  if (!selectedChild) return null;

  const {
    common = {},
    banking = {},
    payments = {},
    lending = {},
    onboarding = {},
    card = {},
  } = data;
  const categories = [
    {name: 'common', data: common, priority: 1},
    {name: 'banking', data: banking, priority: 2},
    {name: 'card', data: card, priority: 3},
    {name: 'payments', data: payments, priority: 4},
    {name: 'lending', data: lending, priority: 5},
    {name: 'onboarding', data: onboarding, priority: 6},
  ];

  let bestMatch = null;

  for (const category of categories) {
    for (const [parent, children] of Object.entries(category.data)) {
      if (children?.[selectedChild]) {
        const childCount = Object.keys(children).length;

        if (
          !bestMatch ||
          childCount < bestMatch.childCount ||
          (childCount === bestMatch.childCount &&
            category.priority < bestMatch.priority)
        ) {
          bestMatch = {
            parent,
            priority: category.priority,
            childCount,
          };
        }
      }
    }
  }

  return bestMatch
    ? {label: bestMatch.parent.replaceAll('_', ' '), value: bestMatch.parent}
    : null;
};
const getParentFields = (data = {}, type) => {
  // const {common = {}, banking = {}, card = {}} = data;
  const {
    common = {},
    banking = {},
    payments = {},
    lending = {},
    onboarding = {},
    card = {},
  } = data;

  const {usecase = type} = JSON.parse(
    localStorage.getItem('currentFlowData') || '{}',
  );

  const usecaseMap = {
    bank: banking,
    banking,
    card,
    payments,
    lending,
    onboarding,
  };

  const uniqueKeys = [
    ...new Set([
      ...Object.keys(common),
      ...Object.keys(usecaseMap[usecase] || {}),
    ]),
  ];

  return uniqueKeys.map(key => ({
    value: key,
    label: formatLabel(key),
  }));
};

const cleanUnderScore = text => text?.replaceAll('_', ' ');
const getChildFields = (parentField, data = {}) => {
  if (!parentField) return [];

  const {
    common = {},
    banking = {},
    payments = {},
    lending = {},
    onboarding = {},
    card = {},
  } = data;
  const parentData =
    common[parentField] ||
    banking[parentField] ||
    card[parentField] ||
    payments[parentField] ||
    lending[parentField] ||
    onboarding[parentField] ||
    {};

  return extractFields(parentData);
};
const getOperators = (parentField, childField, data = {}) => {
  if (!parentField || !childField) return [];
  const fieldData =
    data?.common[parentField]?.[childField] ||
    data?.banking[parentField]?.[childField] ||
    data?.payments[parentField]?.[childField] ||
    data?.lending[parentField]?.[childField] ||
    data?.onboarding[parentField]?.[childField] ||
    data?.card[parentField]?.[childField];

  const operatorType =
    fieldData?.type === 'number' ? 'numeric' : fieldData?.type;

  console.log(fieldData, '>>>>>');

  return (fieldData ? data?.operators[operatorType] || [] : []).map(c => ({
    value: c,
    label: separateCamelCaseWithCaps(c),
    operatorType,
    example: fieldData?.example,
  }));
};
const mergeRules = (stagedRules, publishedRules) => {
  const stagedChanges = stagedRules?.data?.changes || [];
  const latestModifications = new Map();
  const newAdditions = new Map();
  const deletedIds = new Set();

  stagedChanges.forEach(change => {
    const ruleId = change.rule?.id || change.id;

    if (change.type === 'delete') {
      deletedIds.add(ruleId);
      latestModifications.delete(ruleId);
      newAdditions.delete(ruleId);
    } else if (change.type === 'modify') {
      latestModifications.set(ruleId, change);
      newAdditions.delete(ruleId);
    } else if (change.type === 'add' && !latestModifications.has(ruleId)) {
      newAdditions.set(ruleId, change);
    }
  });

  return [
    ...publishedRules.rules.filter(
      rule =>
        !latestModifications.has(rule.id) &&
        !newAdditions.has(rule.id) &&
        !deletedIds.has(rule.id),
    ),
    ...latestModifications.values(),
    ...newAdditions.values(),
  ];
};

export {
  mergeRules,
  getOperators,
  getChildFields,
  getParentFields,
  getSubRuleTheme,
  findParentByChild,
  cleanUnderScore,
  formatLabel,
};
